import { SingleResponseQuestionWidgetServerModelHelper, } from './SingleResponseQuestionServerModel';
import { SingleResponseQuestionHelper, } from '../content/contentBuilder/widgets/SingleResponseQuestionWidget';
import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
export const SingleResponseQuestionWidgetConverter = {
    convertDomainModel: (serverData) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const options = [];
        for (let i = 0; i < serverData.data.options.length; i++) {
            const option = {
                isCorrect: serverData.data.options[i].isCorrect,
                assetId: serverData.data.assets ? (_a = serverData.data.assets[i]) !== null && _a !== void 0 ? _a : undefined : undefined,
                text: serverData.data.options[i].text,
            };
            options.push(option);
        }
        const properties = {
            isRequired: (_b = serverData.properties.isRequired) !== null && _b !== void 0 ? _b : false,
            displayDelayInSeconds: (_c = serverData.properties.displayDelayInSeconds) !== null && _c !== void 0 ? _c : 0,
            isShuffleEnabled: (_d = serverData.properties.isShuffleEnabled) !== null && _d !== void 0 ? _d : true,
            revealAnswers: (_e = serverData.properties.revealAnswers) !== null && _e !== void 0 ? _e : true,
            repeatUntilCorrect: (_f = serverData.properties.repeatUntilCorrect) !== null && _f !== void 0 ? _f : true,
        };
        const feedback = {
            feedbackCorrect: (_g = serverData.data.feedbackCorrect) !== null && _g !== void 0 ? _g : null,
            feedbackIncorrect: (_h = serverData.data.feedbackIncorrect) !== null && _h !== void 0 ? _h : null,
        };
        const titleAssetId = serverData.data.isLastAssetQuestionTitle
            ? serverData.data.assets[serverData.data.assets.length - 1]
            : null;
        return SingleResponseQuestionHelper.create(serverData.id, serverData.trackingIdentifier, serverData.data.questionText, options, properties, feedback, titleAssetId);
    },
    convertToServerModel: (widget) => {
        const optionsServerModel = [];
        const assetIds = [];
        widget.value.data.options.forEach((option) => {
            var _a;
            optionsServerModel.push(SingleResponseQuestionWidgetServerModelHelper.createOption(option));
            assetIds.push((_a = option.assetId) !== null && _a !== void 0 ? _a : null);
        });
        if (widget.value.data.titleAssetId) {
            assetIds.push(widget.value.data.titleAssetId);
        }
        return {
            type: WidgetType.question,
            id: widget._id,
            trackingIdentifier: widget.trackingIdentifier,
            data: {
                isLastAssetQuestionTitle: widget.value.data.titleAssetId !== null,
                questionText: widget.value.data.questionText,
                assets: assetIds,
                options: optionsServerModel,
                feedbackCorrect: widget.value.data.feedbackCorrect,
                feedbackIncorrect: widget.value.data.feedbackIncorrect,
            },
            properties: {
                isRequired: widget.value.properties.isRequired,
                displayDelayInSeconds: widget.value.properties.displayDelayInSeconds,
                isShuffleEnabled: widget.value.properties.isShuffleEnabled,
                revealAnswers: widget.value.properties.revealAnswers,
                repeatUntilCorrect: widget.value.properties.repeatUntilCorrect,
            },
        };
    },
};
